<template>
  <div id="step-1" class="step-one fade-in-fwd">
    <div class="body row">
      <div
        v-for="[key, el] in Object.entries(step1CustomData)"
        :key="el.label"
        v-if="
          checkHasRoles(el.roles)
        "
        class="col-sm-6 type-card"
      >
        <div
          tabindex="0"
          role="button"
          class="type-item"
          :class="{ 'selected': step1.selectedType === key }"
          @keypress="() => selectItem(el, key)"
          @click="() => selectItem(el, key)"
        >
          <div class="type-item__img" :class="el.className">

          </div>
          <div class="type-item__label  medium text-size-small font-24">
            {{ $resourceString[el.label] }}
          </div>
          <div
            class="type-item__description mb-2 text-size-xsmall gray-bold "
            style="font-size: 12px;"
          >
            {{ $resourceString[el.description] }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { step1Data, hasRole } from "../../../../../src/stepTree";
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      step1CustomData: {},
      step1: {
        selectedType:
          "product" |
          null
      }
    };
  },
  created() {
    this.step1CustomData = step1Data;
  },
  computed: {
    ...mapGetters({})
  },
  mounted() {
    this.updateselectedTrayId("");
  },
  methods: {
    ...mapActions({
      resetContentType: "contentWizard/resetContentType",
      setStep: "contentWizard/setStep",
      setContentType: "contentWizard/setContentType",
      setStep1: "contentWizard/setStep1",
      updateselectedTrayId: "contentWizard/updateselectedTrayId",
      selectWebPage: "contentWizard/selectWebPage"
    }),

    checkHasRoles(roles) {
      return hasRole(roles);
    },

    selectItem(el, key) {
      const isDisabled = el.disabled;
      const type = key;
      if(key != 'webPage'){
        this.selectWebPage({});
      }

      if (isDisabled) {
        return;
      }

      this.resetContentType;
      this.setStep(2);

      this.setContentType(step1Data[type]?.defaultType);
      this.setStep1({ selectedType: type });
    }
  }
};
</script>
